module.exports = __webpack_public_path__ + "media/country_flags/ng-67ca2621.png";